import * as Type from './actionsTypes';

const INITIAL_STATE = {
  selectedProgramacaoDiariaDia: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.PROGRAMACAO_DIARIA_DIA_FIND_BY_ID_SUCCESS:
    case Type.SAVE_PROGRAMACAO_DIARIA_DIA_SUCCESS:
    case Type.UPDATE_PROGRAMACAO_DIARIA_DIA_SUCCESS: {
      return {
        ...state,
        selectedProgramacaoDiariaDia: action.data,
      };
    }
    case Type.CLEAR_PROGRAMACAO_DIARIA_DIA: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getSelectedProgramacaoDiariaDia = state =>
  state.rootState.programacaoDiariaDia.selectedProgramacaoDiariaDia;
